import { definePortalChrome } from '@p31ca/design-core/compositions/portal-chrome'
import { NAV_ITEMS } from '../lib/nav'
import { useUI } from '../lib/store'

/**
 * chrome.ts — the forge's chrome CONFIG (rule 0: chrome is data, not markup).
 * profile 'compact' (the live L1 compact render): brand + inline trailing
 * actions — NO drawer, overflow, chips. The A18 drawerKey/drawerId stay a
 * namespace reservation: no drawer renders, but the key/id remain unique so a
 * future step-up to 'full' cannot collide. The Topbar.tsx / SidebarNav.tsx
 * bodies are thin data+ports re-exporters over this config (each ≤15 lines).
 */
export const chrome = definePortalChrome({
  profile: 'compact',
  brandName: 'P31 FORGE',
  brandLabel: 'P31 Forge — Home. Click to cycle theme.',
  brandMark: '31',
  org: 'forge',
  drawerKey: 'p31.sidebar.v2.forge',
  drawerId: 'forge-sidebar-drawer',
  capabilities: ['theme', 'spoons'],
  mobileOverflow: 'never',
  nav: { ariaLabel: 'Main navigation', items: NAV_ITEMS },
  adapters: { ui: useUI },
})

export default chrome